import { useQuery } from '@tanstack/react-query';
import { Rank } from '@domain/insights/models/Rank';
import { container } from '@infrastructure/container';


export const useSearchTermRanks = (searchTerm: string) => {
    const {
        data: ranks,
        isLoading: isLoadingRanks,
        error: ranksError
    } = useQuery<Rank[]>({
        queryKey: ['ranks', searchTerm],
        queryFn: async () => {
            const result = await container.insightsRepository.getRanksBySearchTerm(searchTerm);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        },
        enabled: !!searchTerm,
        refetchOnWindowFocus: false,
        staleTime: 0,
        refetchOnMount: true,
    });

    return {
        ranks,
        isLoading: isLoadingRanks,
        error: ranksError
    };
};